import { Box, BoxProps } from '@mui/material';

import { useResponsive } from '@/hooks/useResponsive';

export function MobileOnly(props: BoxProps) {
  const { isMobile } = useResponsive();

  if (isMobile) return <Box {...props} />;

  return null;
}

export function DesktopOnly(props: BoxProps) {
  const { isDesktop } = useResponsive();

  if (isDesktop) return <Box {...props} />;

  return null;
}
